class Alert
  @success: (text, title, timeout) -> new Alert('success', text, title, timeout)
  @error: (text, title, timeout) -> new Alert('error', text, title, timeout)
  @warning: (text, title, timeout) -> new Alert('warning', text, title, timeout)
  @info: (text, title, timeout) -> new Alert('info', text, title, timeout)

  constructor: (@type, @text, @title = undefined, @timeout = 5000, call = true) -> @call() if call

  getColor = (type) ->
    switch type
      when 'success' then 'rgb(115, 158, 115)'
      when 'error' then 'rgb(196, 106, 105)'
      when 'warning' then 'rgb(199, 145, 33)'
      when 'info' then 'rgb(50, 118, 177)'
      else 'rgb(50, 118, 177)'

  getIcon = (type) ->
    switch type
      when 'success' then 'fa fa-check'
      when 'error' then 'fa fa-frown-o'
      when 'warning' then 'fa fa-exclamation-triangle'
      when 'info' then 'fa fa-info-circle'
      else ''

  call: ->
    @color = if @color? then @color else getColor(@type)
    @icon = if @icon? then @icon else getIcon(@type)

    configs =
      content: @text
      title: @title
      timeout: if @timeout then @timeout else undefined
      color: @color
      sound: false

    if @title?
      configs.icon = @icon
    else
      configs.iconSmall = @icon

    $.smallBox(configs)

angular.module('eficienciaFiscalModule').factory('Alert', -> Alert)

window.Alert = Alert
